import Vue from 'vue'
import moment from 'moment'
import store from '../store'

const currentLocale = () => store.state['Account'].account.locale

export const filters = {
    localedDateTime(date) {
        return moment(date).locale(currentLocale()).format('DD MMMM, HH:mm');
    },
    shortText(text, len = 40) {
        if (text) {
            let shorten = text.slice(0, len);
            return `${shorten}${text.length > len ? '...' : ''}`
        } else return ''
    },
    shortDescription(text) {
        let len = 60
        if (text) {
            let shorten = text.slice(0, len).trim();
            return `${shorten}${text.length > len ? '...' : ''}`
        } else return ''
    },
    capitalize(text) {
        return text.toUpperCase()
    },
    localedDate(date) {
        return moment(date).locale(currentLocale()).format('D MMMM');
    },
    date(date) {
        return date ? moment(date).locale(currentLocale()).format('DD.MM.YYYY') : '-';
    },
    dateTime(date) {
    return date ? moment(date).locale(currentLocale()).format('HH:mm, DD.MM.YYYY') : '-';
  },
  localedDateWeekday(date) {
    return moment(date).locale(currentLocale()).format('dddd');
  },
  localedDateWithYear(date) {
    return moment(date).locale(currentLocale()).format('D MMMM, YYYY');
  },
  timeFormat(date) {
    return moment(date).locale(currentLocale()).format('HH:mm');
  },
  localedShortDate(date) {
    return moment(date).locale(currentLocale()).format('D MMM');
  },
  localedRelativeDate(date) {
    return moment(date).locale(currentLocale()).fromNow();
  },
  million(num) {
    let millions = num / 1000000
    return Math.round(millions * 100) / 100
  },
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  stripHtml(html) {
    let tmp = document.createElement("DIV")
    tmp.innerHTML = html
    return tmp.textContent || tmp.innerText || ""
  }
}

const filterInstaller = {
  install(Vue) {
    for (let key in filters) {
      Vue.filter(key, filters[key])
    }
  }
}
export {filterInstaller}
